<loader *ngIf='_isLoading'></loader>

<list-products
	[_response]='_response'
	[_isLoading]='_isLoading'
	[_showPagination]="true"
	(changePage)='onChangePage($event)'
></list-products>